// extracted by mini-css-extract-plugin
module.exports = {"link":"Home_nav_link__1w0QB","linkActive":"Home_nav_linkActive__1auaF","downloadModal":"Home_nav_downloadModal__nboRI"};